import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import './style.scss';

import * as actions from 'actions';
import { getLinks } from 'selectors';
import { LinkShape } from 'entities';

class Links extends Component {

  componentDidMount() {
    if (this.props.onDidMount) {
      this.props.onDidMount();
    }
  }

  renderLink(link, index) {
    const { image, url, title } = link;
    const className = classnames('link-inner', {'has-logo': !!image});

    // The next block uses classNames that are shared with index.html
    // If you change them, please, rename in index.html too
    return (
      <div className={className} key={index}>
        {image &&
        <div className="logo">
          <a target="_blank" href={url}>
            <img src={image} alt={title} />
          </a>
        </div>
        }
        <h4>{title}</h4>
        <a target="_blank" href={url} className="Link">{url}</a>
      </div>
    );
  }

  render() {
    return (
      <section className="Links content-wrapper has-background">
        <div className="wrapper-small">
          <h1>{__('members.links.title')}</h1>

          {(() => {
            if(this.props.isFetching) {
              return (
                <div className="while-loading">
                  <h3>{__('members.links.loading')}</h3>
                </div>
              );
            } else {
              return (
                <div className="outer-links is-inside-app">
                  {this.props.links.map((link, index) => this.renderLink(link, index))}
                </div>
              );
            }
          })()}

        </div>
      </section>
    );
  }

}

Links.propTypes = {
  onDidMount: PropTypes.func,
  isFetching: PropTypes.bool,
  links: PropTypes.arrayOf(LinkShape)
};

const mapStateToProps = state => {
  return {
    ...getLinks(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onDidMount: () => {
      dispatch(actions.linksFetch());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Links);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Links/index.js
 **/